import "./ServicesList.scss";
import clockSVG from "../../assets/icons/clock.svg";

export default function ServicesList() {
  return (
    <section className="servicesList">
      <h2 className="servicesList__header">our services</h2>
      <div className="servicesList__services">
        <section className="servicesList__card servicesList__card--odd">
          <h3 className="serviceCard__title">Sunday school</h3>
          <p className="serviceCard__desc">
            Join us for an in-depth study of a book of the Bible, its history,
            and its significance.
          </p>
          <div className="serviceCard__schedule">
            <img src={clockSVG} alt="Clock" className="serviceCard__clock" />
            <h4 className="serviceCard__time">Sunday 9:45 am</h4>
          </div>
        </section>
        <section className="servicesList__card">
          <h3 className="serviceCard__title">Coffee and fellowship</h3>
          <p className="serviceCard__desc">
            Join us for some coffee and a time of fellowship right before
            service starts.
          </p>
          <div className="serviceCard__schedule">
            <img src={clockSVG} alt="Clock" className="serviceCard__clock" />
            <h4 className="serviceCard__time">Sunday 10:30 am</h4>
          </div>
        </section>
        <section className="servicesList__card servicesList__card--odd">
          <h3 className="serviceCard__title">worship service</h3>
          <p className="serviceCard__desc">
            We gather to worship through prayer, singing, Scripture reading,
            giving, and preaching the Word.
          </p>
          <div className="serviceCard__schedule">
            <img src={clockSVG} alt="Clock" className="serviceCard__clock" />
            <h4 className="serviceCard__time">Sunday 11:00 am</h4>
          </div>
        </section>
        <section className="servicesList__card">
          <h3 className="serviceCard__title">Tuesday Women's Bible Study</h3>
          <p className="serviceCard__desc">
            Gather with like-minded sisters to share prayer requests,
            encouragement, and accountability in this weekly gathering.
          </p>
          <div className="serviceCard__schedule">
            <img src={clockSVG} alt="Clock" className="serviceCard__clock" />
            <h4 className="serviceCard__time">Tuesday 6:00 pm</h4>
          </div>
        </section>
        <section className="servicesList__card servicesList__card--odd">
          <h3 className="serviceCard__title">Wednesday night bible study</h3>
          <p className="serviceCard__desc">
            Join us as we go chapter by chapter through the book of Matthew
            understanding its context, history, and significance.
          </p>
          <div className="serviceCard__schedule">
            <img src={clockSVG} alt="Clock" className="serviceCard__clock" />
            <h4 className="serviceCard__time">Wednesday 6:00 pm</h4>
          </div>
        </section>
        <section className="servicesList__card servicesList__card">
          <h3 className="serviceCard__title">Saturday Men's Bible Study</h3>
          <p className="serviceCard__desc">
            Join our men's group to study the Word of God, encourage one
            another, and to pursue Godliness in our lives.
          </p>
          <div className="serviceCard__schedule">
            <img src={clockSVG} alt="Clock" className="serviceCard__clock" />
            <h4 className="serviceCard__time">Saturday 9:00 am</h4>
          </div>
        </section>
      </div>
    </section>
  );
}
